import React, { useEffect } from "react";
import AlertMessageStyle from "./AlertMessage.style";
import { Alert } from "@mui/material";
import { useAlert, ALERT_ACTIONS } from "../../context/AlertProvider";
import useType from "../../utils/hooks/useType";

export default function AlertMessage() {
  const [{ alerts }, dispatchAlert] = useAlert();
  const [alertStyles, setAlertStyles] = useType("object", {
    right: "-400px",
    backgroundColor: "unset",
    transition: "200ms cubic-bezier(0.4, 0, 1, 1) 0s",
  });

  const currentAlert = alerts[0];

  useEffect(() => {
    if (!currentAlert) return;
    setAlertStyles({
      right: "0px",
      backgroundColor:
        currentAlert?.status === "Success"
          ? "var(--carter-success)"
          : currentAlert?.status === "Error"
          ? "var(--carter-error)"
          : currentAlert?.status === "Info"
          ? "var(--carter-info)"
          : currentAlert?.status === "Warning"
          ? "var(--carter-brand)"
          : "var(--carter-faint)",
      transition: "200ms cubic-bezier(0.4, 0, 1, 1) 0s",
    });

    setTimeout(() => {
      setAlertStyles({
        right: "-400px",
        transition: "200ms cubic-bezier(0.4, 0, 1, 1) 0s",
      });

      setTimeout(() => {
        dispatchAlert({ type: ALERT_ACTIONS.REMOVE }); // Removes the first alert from the alerts array, following FIFO (First In, First Out)
      }, 200); // 200 to match the transition duration when moving the alert off screen
    }, currentAlert?.duration);
  }, [currentAlert, setAlertStyles, dispatchAlert]);

  return (
    <AlertMessageStyle style={alertStyles}>
      <Alert
        severity={currentAlert?.status?.toLowerCase() || "info"}
        sx={{ zIndex: "1000" }}
      >
        <span
          onClick={() =>
            dispatchAlert({ type: ALERT_ACTIONS.SET_DURATION, payload: 0 })
          }
          className="alert-close"
        >
          &times;
        </span>
        <span
          onClick={() => {
            dispatchAlert({
              type: ALERT_ACTIONS.SET_DURATION,
              payload: 1000000,
            });
          }}
        >
          {currentAlert?.status} - {currentAlert?.message}
        </span>
      </Alert>
    </AlertMessageStyle>
  );
}
